var StoreModel = Backbone.Model.extend({
  parse: function(data) {
    console.log('will parse');
    var storeAttributeModels = _.map(data.storeAttributeIds, function(id) {
      return bookedby.app.staticData.storeAttributeMap[id];
    });

    data.storeAttributes = new Backbone.Collection(storeAttributeModels);
    delete data.storeAttributeIds;

    return data;
  },

  toJSON: function() {
    var baseJSON = _.clone(this.attributes);
    baseJSON.storeAttributes = this.get('storeAttributes').toJSON();
    return baseJSON;
  }
});

module.exports = StoreModel;